import React, { VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import { MediaColumn, IMAGE_SIZE } from '/components/BlockColumns';
import { BlockProps } from '/types';

const BlockFullImage: VFC<BlockProps> = ({
  blockContent,
  presentOption,
  ...props
}) => (
  <ArticleBlock
    {...props}
    blockContent={blockContent}
    presentOption={presentOption}
    noTitle
  >
    {'columns' in blockContent ? (
      <>
        {!blockContent?.image?.hidden &&
          blockContent?.columns?.list[0].name === 'media' && (
            <MediaColumn
              elements={blockContent?.columns?.list[0].elements}
              imageSize={IMAGE_SIZE.FULL}
              presentOption={presentOption}
            />
          )}
      </>
    ) : (
      <MediaColumn
        elements={blockContent}
        imageSize={IMAGE_SIZE.FULL}
        presentOption={presentOption}
      />
    )}
  </ArticleBlock>
);

BlockFullImage.displayName = 'BlockFullImage';
export default BlockFullImage;
